import { Loading } from '@medplum/react';
import type { JSX, ReactNode } from 'react';
import { Navigate } from 'react-router';
import type { Permission, Role } from '../utils/permissions';
import { hasPermission } from '../utils/permissions';

interface RequirePermissionProps {
  role: Role | undefined;
  isAdmin: boolean;
  loading: boolean;
  permission: Permission;
  redirectTo?: string;
  children: ReactNode;
}

export function RequirePermission({
  role,
  isAdmin,
  loading,
  permission,
  redirectTo,
  children,
}: RequirePermissionProps): JSX.Element {
  if (loading) {
    return <Loading />;
  }

  if (!hasPermission({ role, permission, isAdmin })) {
    return <Navigate to={redirectTo ?? '/'} replace />;
  }

  return <>{children}</>;
}
